<template>
  <div id="fireflies">
    <b-modal
      :active.sync="released"
      :canCancel="true"
    >
      <released-firefly-modal :color="releasedColor"></released-firefly-modal>
    </b-modal>
    <p class="header">{{ header }}</p>
    <div class="jars">
      <div
        class="jar"
        v-for="jar in jars"
        :key="jar.color"
      >
        <firefly-canvas
          class="fireflies"
          :width="50"
          :height="100"
          :count="5"
        ></firefly-canvas>
        <jar
          :jar="jar"
          :class="{ full: full(jar) }"
          @click.native="releaseIfFull(jar)"
        ></jar>
        <div class="progress-bar">
          <progress-bar
            size="large"
            :val="progress(jar)"
            :bar-color="jar.color"
            v-if="!full(jar)"
          ></progress-bar>
        </div>
      </div>
    </div>
    <p class="info">{{ info }}</p>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import {
    FULL_COUNT,
    JAR_COUNT,
    TIME_TO_FIREFLY
  } from "@/store_modules/fireflies";
  import Jar from "@/components/Fireflies/JarIcon.vue";
  import FireflyCanvas from "@/components/Fireflies/FireflyCanvas.vue";
  import ReleasedFireflyModal from "@/components/Fireflies/ReleasedFireflyModal.vue";
  import ProgressBar from "vue-simple-progress";

  export default {
    components: {
      Jar,
      ProgressBar,
      ReleasedFireflyModal,
      FireflyCanvas
    },
    data() {
      return {
        released: false,
        releasedColor: ""
      };
    },
    computed: {
      ...mapState({
        jars: state => state.fireflies.jars
      }),
      ...mapGetters(["fullJars"]),
      info() {
        switch (this.state) {
          case "collecting":
            return "When you get a full jar release it for a special surprise";
          case "full":
            return "Make sure you can see the tree and then tap the jar to release the fireflies";
          default:
            return "";
        }
      },
      header() {
        switch (this.state) {
          case "collecting":
            return "YOUR PATHFINDER IS COLLECTING FIREFLIES FOR YOU!";
          case "full":
            if (this.fullJars.length > 1)
              return "YOU HAVE FULL JARS OF FIREFLIES!";
            else return "YOU HAVE A FULL JAR OF FIREFLIES!";
          default:
            return "";
        }
      },
      state() {
        if (this.fullJars.length > 0) {
          return "full";
        } else {
          return "collecting";
        }
      }
    },
    methods: {
      ...mapActions(["addFirefly", "releaseJar"]),
      full(jar) {
        return this.fullJars.includes(jar);
      },
      progress(jar) {
        return (jar.fireflies / FULL_COUNT) * 100;
      },
      releaseIfFull(jar) {
        if (this.full(jar)) {
          this.released = true;
          this.releasedColor = jar.color;
          this.releaseJar(jar);
        }
      },
      addFireflyIfNotEmpty() {
        if (this.fullJars.length != JAR_COUNT) {
          this.addFirefly();
        }
      }
    },
    mounted() {
      this.interval = setInterval(this.addFireflyIfNotEmpty, TIME_TO_FIREFLY);
    },
    beforeDestroy() {
      clearInterval(this.interval);
    }
  };
</script>

<style lang="scss">
  #fireflies {
    .header,
    .info {
      width: 90%;
      text-align: center;
      margin: auto;
    }

    .header {
      font-size: 1.5em;
      font-weight: bold;
    }

    .jars {
      display: flex;
      width: 100%;
      justify-content: center;
      margin-top: 0.5em;
      margin-bottom: 0.5em;

      .jar {
        width: 50%;
        padding: 0.25em;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        .fireflies {
          position: absolute;
          top: 15%;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
          pointer-events: none;
        }

        .progress-bar {
          height: 12px;
          margin-top: 12px;
        }
      }
    }
  }
</style>
